import {Component} from '@angular/core';
import {StrapiService} from '../../../services/strapi-service/strapi.service';
import {Observable} from 'rxjs';
import {Event} from '../../../model/strapi/event/event';

@Component({
    selector: 'app-event-page',
    templateUrl: './event-page.component.html',
    styleUrls: ['./event-page.component.scss'],
    standalone: false
})
export class EventPageComponent {

  events$: Observable<Event[]> = this.strapiService.getEvents();

  constructor(private readonly strapiService: StrapiService) {
  }

}
